









































import store from "@/store";
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
	props: {
		lang: {
			type: String,
		},
		org: {
			type: String,
			required: true,
		},
		authKey: {
			type: String,
		},
	},
	data() {
		return {
			acceptance: false as boolean,
         organisationName: '' as string,
         privacyStatementUrl: '' as string
		};
	},
	mounted() {
		if (this.$props.authKey) {
			store.dispatch("auth", this.$props.authKey);
		}
		if (this.$props.org) {
			if (this.$props.lang) {
				let payload = { org: this.$props.org, lang: this.$props.lang };
				store.commit("setOrgLang", payload);
			}
			axios.defaults.headers.org = this.$props.org;
		}
		this.getOrgServices();
      this.getOrgInfo();
	},
	computed: {
		isDisabled(): boolean {
			return !this.acceptance;
		},
		// storeAuthKey() {
		//     return store.state.authKey;
		// },
		storeAuthObject() {
			return store.state.strongAuth;
		},
	},
	methods: {
		authenticate() {
			location.assign(
				`${process.env.VUE_APP_AUTH_URL}/flow/start?endUrl=${process.env.VUE_APP_AUTH_URL_END}/auth/${this.$props.org}/${this.$props.lang}`
			);
		},
		toService() {
			let org = localStorage.getItem("org") as string;
			let lang = localStorage.getItem("lang") as string;
			this.$router.push({
				name: "Itsepalvelu",
				params: { org: org, lang: lang },
			});
		},
		getOrgServices() {
			axios.get("itsepalvelu/organizationservices").then((resp) => {
				let tunnisteArray = [] as string[];
				resp.data.forEach((x: any) => {
					tunnisteArray.push(x.tunniste);
				});
				const payload = { orgServices: tunnisteArray };
				this.$store.commit("setAvailableServices", payload);
			});
		},
      getOrgInfo(){        
         axios.get("itsepalvelu/organizationinfo").then((resp) => {            
            this.organisationName = resp.data.nimiItsepalvelussa;
            this.privacyStatementUrl = resp.data.itsepalveluTietosuojaselosteUrl;
         });         
      }
	},
});
